import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../Components/Common/Header";
import Footer from "../Components/Common/Footer";
import Hero from "../Components/Pages/Home/Hero"
import SpeedDemo from "../Components/Pages/Home/SpeedDemo";
import Features from "../Components/Pages/Home/Features";
import Methodology from "../Components/Pages/Home/Methodology";
import AnalysisTools from "../Components/Pages/Home/AnalysisTools";
import Comparison from "../Components/Pages/Home/Comparison";
import LivePreview from "../Components/Pages/Home/LivePreview";
import ROICalculator from "../Components/Pages/Home/ROICalculator";
import Benefits from "../Components/Pages/Home/Benefits";
import Demo from "../Components/Pages/Home/Demo";
import Testimonial from "../Components/Pages/Home/InfiniteTestimonials";
import { fetchSiteSettingsPublic } from "../Helpers/siteSettingsSlice";

const Home = () => {
    const dispatch = useDispatch();
    const { groupedSettings } = useSelector((state) => state.siteSettings);

    useEffect(() => {
        dispatch(fetchSiteSettingsPublic());
    }, [dispatch]);

    const header = groupedSettings?.header || {};
    const home = groupedSettings?.home || {};
    const footer = groupedSettings?.footer || {};

    return (
        <>
            <Header label="home" />
            <Hero siteSettings={{ ...header, ...home }} />
            <SpeedDemo siteSettings={home} />
            <Features siteSettings={header} />
            <Methodology />
            <AnalysisTools />
            <Comparison />
            <LivePreview />
            <ROICalculator />
            <Testimonial />
            <Benefits />
            <Demo siteSettings={footer} />

            <Footer label="home" siteSettings={footer} />
        </>
    );
};

export default Home;
